import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=c8098e64&"
import script from "./ModuleList.vue?vue&type=script&lang=js&"
export * from "./ModuleList.vue?vue&type=script&lang=js&"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=c8098e64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports